import React, { useState } from "react";
import LogoImg from "./../../assets/images/Bharat_Dhara/Logo/bd_large_jpg.jpg";
import LogoIconImg from "./../../assets/images/Bharat_Dhara/Logo/Important/BharatDharaIconOnly.png";
import DarkLogoImg from "./../../assets/images/Bharat_Dhara/Logo/bd_white_font_png_noslogan.png";

export default function SidebarLogo({ toggleMenuSidebar, toggleWebMenu, HideWeb }) {
  return (
    <div className="sidebar-logo">
      <div>
        <a href="index.html" className="logo logo-normal">
          <img src={LogoIconImg} alt="Logo" />
          {HideWeb == false && <span>Bharat Dhara</span>}
        </a>

        <a href="index.html" className="logo-small">
          <img src={LogoIconImg} alt="Logo" />
          {HideWeb == false && <span>Bharat Dhara</span>}
        </a>

        <a href="index.html" className="dark-logo">
          <img src={DarkLogoImg} alt="Logo" />
          {HideWeb == false && <span>Bharat Dhara</span>}
        </a>
      </div>

      <button
        id="toggle_btn"
        className="sidenav-toggle-btn btn border-0 p-0 active"
        onClick={toggleWebMenu}
      >
        <i className="ti ti-arrow-left text-body"></i>
      </button>

      <button className="sidebar-close" onClick={toggleMenuSidebar}>
        <i className="ti ti-x align-middle"></i>
      </button>
    </div>
  );
}
